export const iconFontAwesomeAccessibilityHandsAslInterpreting = (
	<i className="fa-solid fa-hands-asl-interpreting"></i>
);
